import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SearchProductsService } from './service/search-products.service';
import { Product } from '../products/interfaces/products.interface';
import { ModalViewProductComponent } from "../modal-view-product/modal-view-product.component";
import { EstablishmentIsOpenService } from '../../../../core/service/estasblishment-is-open.service';
import { ProductModalService } from '../../../../core/service/product-modal.service';
import { ProductData } from '../list-products/interfaces/list-products-new.interface';

@Component({
  selector: 'establishment-main-bar-search-products',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-bar-products.component.html',
  styleUrl: './search-bar-products.component.css'
})
export class SearchBarProductsComponent implements OnInit {
  isActive: boolean = false;
  @Input() isOpen: boolean = false;
  private searchBarElement: HTMLElement | null = null;
  products: ProductData[] = [];
  searchTerm: string = '';
  filteredProducts: ProductData[] = [];
  showResults: boolean = false;
  selectedProduct: ProductData | null = null;
  readonly defaultImage = 'assets/imagen_default.png';
  showModal: boolean = false;
  constructor(private elementRef: ElementRef,
    private searchProductsService: SearchProductsService,
    private establishService: EstablishmentIsOpenService,
    private productModalService: ProductModalService
  ) {

  }

  ngOnInit(): void {
    this.searchBarElement = this.elementRef.nativeElement.querySelector('.search-container');


  }

  toggleActive(event: Event): void {
    event.stopPropagation();
    this.isActive = true;
    this.products = this.searchProductsService.getProducts();
    // console.log('productos en search', this.products);

  }

  onSearchInput(event: any): void {
    this.searchTerm = event.target.value;
    this.filteredProducts = this.searchProductsService.searchProducts(this.searchTerm);
    this.showResults = this.searchTerm.length > 0;
  }
  closeModal() {
    this.productModalService.closeModal();
    this.selectedProduct = null;
  }

  selectProduct(product: ProductData): void {
    // if (this.establishService.isEstablishmentOpen(product.apertura, product.cierre, product.isOpen)) {
      this.selectedProduct = product;
      this.productModalService.openModal(product); // Usar el servicio global para abrir el modal
      this.searchTerm = product.pd_name;
      this.showResults = false;
    // }
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.searchTerm = '';
    this.showResults = false;
    this.filteredProducts = [];
    const inputElement = this.elementRef.nativeElement.querySelector('input');
    if (inputElement) {
      inputElement.value = '';
      inputElement.focus();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Check if the click was outside the search bar
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isActive = false;
    }
  }
  onImageError(event: any): void {
    event.target.src = this.defaultImage;
  }
}
